import "@webex/widgets/dist/css/webex-widgets.css";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import withReducer from "app/store/withReducer";
import React from "react";
import connect from "react-redux/es/connect/connect";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import XAPPButton from "../Button/XAPPButton";
import * as Actions from "./Store/Actions/WebexActions";
import reducer from "./Store/Reducers/WebexReducer";

class WebexMeetingToogle extends XAPPComponent {

   render() {
      const { toogleMeeting } = this.props;
      return (
         <XAPPButton
            tooltip={{ placement: "top", title: "Videochamada" }}
            type="Icon"
            className="p-6"
            variant="contained"
            color="dafault"
            iconProps=""
            icon={"video"}
            onClick={() => toogleMeeting()}
         />
      );
   }
}

function mapDispatchToProps(dispatch) {
   return bindActionCreators({
      toogleMeeting: Actions.toogleMeeting,
   }, dispatch);
}


export default withReducer("Webex", reducer)(withRouter(connect(null, mapDispatchToProps)(WebexMeetingToogle)));
